/*
=========================================================
* Vuetify Material Dashboard 2 PRO - v3.0.0
=========================================================

* Product Page:  https://www.creative-tim.com/product/vuetify-material-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import DashboardPlugin from "./plugins/dashboard-plugin";
import HeaderAdmin from './components/Layout/HeaderAdmin.vue'
import FooterAdmin from './components/Layout/FooterAdmin.vue'
import Header from './components/Layout/Header.vue'
import Footer from './components/Layout/Footer.vue'
import HeaderDealer from './components/Layout/HeaderDealer.vue'
import FooterDealer from './components/Layout/FooterDealer.vue'
const axios = require('axios').default;
import VueSignature from "vue-signature-pad";
Vue.use(VueSignature);
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY, // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  version: '', // Optional
});
import * as VueGoogleMaps from 'vue2-google-maps'
 
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
})
import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueMeta from 'vue-meta';

Vue.use(VueMeta);
Vue.use(VueToast);
import { VueMaskDirective } from 'v-mask'
import vueVimeoPlayer from 'vue-vimeo-player'
Vue.use(vueVimeoPlayer)
Vue.directive('mask', VueMaskDirective);
Vue.component('vue-header-admin', HeaderAdmin)
Vue.component('vue-footer-admin', FooterAdmin)
Vue.component('vue-header-dealer', HeaderDealer)
Vue.component('vue-footer-dealer', FooterDealer)
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);
Vue.component('vue-header', Header)
Vue.component('vue-footer', Footer)
Vue.config.productionTip = false;
const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
      },
});
http.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// Add response interceptor to handle token invalidation
http.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      const status = error.response.data?.status;
      if (status === 'Token is Invalid - Password Changed' ||
          status === 'Token is Invalid' ||
          status === 'Token is Expired' ||
          status === 'Authorization Token not found') {

        // Clear all auth data
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('company_id');
        localStorage.removeItem('email');
        localStorage.removeItem('role');
        localStorage.removeItem('name');
        localStorage.removeItem('is_admin');
        localStorage.removeItem('company_logo');
        localStorage.removeItem('company_logo_bg');

        // Show appropriate message
        if (status === 'Token is Invalid - Password Changed') {
          Vue.$toast.error('Your password was changed. Please login again for security.', {
            position: 'top-right',
            duration: 5000
          });
        }

        // Redirect to login
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

window.axios = http;
window.Vue = Vue;
// Photoswipe Gallery
import Photoswipe from "vue-pswipe";
Vue.use(Photoswipe);

// Import vehicle tracking mixin
import vehicleTrackingMixin from './mixins/vehicleTracking';
import digitalAssistantService from './services/digitalAssistantService';

// Register global mixin
Vue.mixin(vehicleTrackingMixin);

// Make digital assistant service available globally
Vue.prototype.$digitalAssistant = digitalAssistantService;

// plugin setup
Vue.use(DashboardPlugin);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
